import {combineReducers} from 'redux'
import types from 'actions/types'

export const search = (state = '', action) => {
  switch (action.type) {
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_ALL_PRICE_LISTS:
      return ''
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SEARCH_PART_CATEGORIES:
      return action.search
          ? action.search
          : ''
    default:
      return state
  }
}

export const priceLists = (state = [], action) => {
  switch (action.type) {
    case types.PART_CATEGORY_TREE_SELECT_FIELD_LOAD_PRICE_LISTS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const priceListId = (state = null, action) => {
  switch (action.type) {
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_ALL_PRICE_LISTS:
      return null
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SEARCH_PART_CATEGORIES:
      return null
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PRICE_LIST:
      return action.priceListId
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PART_CATEGORY:
      return action.partCategory.priceListId
    case types.PART_CATEGORY_TREE_SELECT_FIELD_LOAD_PART_CATEGORY_SUCCESS:
      return action.data.priceListId
    default:
      return state
  }
}

export const categories = (state = [], action) => {
  switch (action.type) {
    case types.PART_CATEGORY_TREE_SELECT_FIELD_LOAD_PART_CATEGORIES_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const category = (state = null, action) => {
  switch (action.type) {
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_ALL_PRICE_LISTS:
      return null
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PRICE_LIST:
      return null
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SEARCH_PART_CATEGORIES:
      return null
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PART_CATEGORY:
      return action.partCategory
    default:
      return state
  }
}

export const categoryId = (state = null, action) => {
  switch (action.type) {
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_ALL_PRICE_LISTS:
      return null
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PRICE_LIST:
      return null
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SEARCH_PART_CATEGORIES:
      return null
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PART_CATEGORY:
      return action.partCategory.id
    case types.PART_CATEGORY_TREE_SELECT_FIELD_LOAD_PART_CATEGORY_SUCCESS:
      return action.data.id
    default:
      return state
  }
}

export const parentCategories = (state = [], action) => {
  switch (action.type) {
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_ALL_PRICE_LISTS:
      return []
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PRICE_LIST:
      return []
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SEARCH_PART_CATEGORIES:
      return []
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PART_CATEGORY:
      const partCategoryIndex = state.findIndex(partCategory => partCategory.id === action.partCategory.id)
      return partCategoryIndex >= 0
          ? state.slice(0, partCategoryIndex + 1)
          : state
    default:
      return state
  }
}

export const parentCategoryIds = (state = [], action) => {
  switch (action.type) {
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_ALL_PRICE_LISTS:
      return []
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PRICE_LIST:
      return []
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SEARCH_PART_CATEGORIES:
      return []
    case types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PART_CATEGORY:
      const partCategoryIndex = state.findIndex(partCategory => partCategory.id === action.partCategory.id)
      return partCategoryIndex >= 0
          ? state.slice(0, partCategoryIndex + 1)
          : state
    default:
      return state
  }
}

export default combineReducers({
  search,
  priceLists,
  priceListId,
  categories,
  category,
  categoryId,
  parentCategories,
  parentCategoryIds,
})